import React from "react";
import "../scss/About.scss";
import about from "../Images/about.png";
import deal from "../Images/deal-with-expert.png";
import calender from "../Images/calender-icon.png";
import money from "../Images/money-icon.png";
import get_instant from "../Images/get-instant.png";
import email_icon from "../Images/email-icon.png";
import { useGlobalContext } from "../components/Context";

const AboutPage = () => {
	const {
		handleModal,
		changeHandler,
		sendWaitlist,
		sendHelpdesk,
		helpDeskData,
		data,
		helpDeskChangeHandler,
	} = useGlobalContext();

	

	return (
		<>
			<div className="about-hero">
				<div className="about-hero__wrapper">
					<p className="about-hero__topic">About the Currency MarketPlace</p>
					<div className="about-hero__hero-section">
						<div className="about-hero__left">
							<img src={about} alt="about" />
						</div>

						<div className="about-hero__right">
							<p>
								For individuals and businesses who want to trade beyond their
								borders, iExchange is a currency marketplace that enables you to
								convert your currency securely, conveniently and smartly unlike
								the Banks that will limit your orders or Bureau De change that
								raise concerns for security and their crude way of operations,
								our platform provides you with a marketplace and support systems
								to convert smarter, safer and conveniently with anyone anywhere.
							</p>
							<p>
								The currency Marketplace is a peer-to-peer and FX broker powered
								market place that brings together parties that need to exchange
								a commodity (currency, digital or paper currency) on their
								agreed terms. The platform is a bridge between the buyer and the
								seller, creating a system of trust in an erstwhile trustless
								system.
							</p>
						</div>
					</div>
				</div>
			</div>

			<div className="deal">
				<div className="deal__left">
					<img src={deal} alt="deal-with-expert" />
				</div>

				<div className="deal__right">
					<div className="deal__right__top">
						<p className="deal__right__top__topic">Deal with Expert</p>
						<p>
							Our team of experts help to dissect the market and provide you
							with the best information to make the accurate choices.
						</p>
					</div>
					<div className="deal__right__bottom">
						<div className="deal__cards">
							<div className="deal__icons">
								<img src={money} alt="money" />
							</div>
							<p className="deal__cards__topic">Exchange for the best rate</p>
							<p className="deal__cards__text">
								With iExchange,you have access to thousands of requests you can
								pick from to suit your needs.
							</p>
						</div>

						<div className="deal__cards">
							<div className="deal__icons">
								<img src={calender} alt="calender" />
							</div>
							<p className="deal__cards__topic">
								Our services are available 24/7
							</p>
							<p className="deal__cards__text">
								You need not worry about the time, you can trade at any time of
								the day conveniently.
							</p>
						</div>
					</div>
				</div>
			</div>

			{/* <div className="blog">
        <div className="blog__heading">
          <p>Latest Blog</p>
          <h5 className="blog__heading__span">Our Evolution</h5>
        </div>

        <div className="blog__wrapper">
          <div className="blog__cards">
          <div className="blog__image">
            <img src={best_way} alt="best-way"/>
          </div>
            
            <p className="blog__topic">Best Way Rise Curreancy</p>
            <p className="blog__date">24 January, 2021</p>
            <p className="blog__words">
              Lorem ipsum dolor sit amet, consectetur sing to  sed do eiusmod tempor incididunt ut labore  dolore magna aliqua dolor.
            </p>
          </div>

          <div className="blog__cards">
            <img src={best_way} alt="best-way"/>
            <p className="blog__topic">Best Way Rise Curreancy</p>
            <p className="blog__date">26 January, 2021</p>
            <p className="blog__words">
              Lorem ipsum dolor sit amet, consectetur sing to  sed do eiusmod tempor incididunt ut labore  dolore magna aliqua dolor.
            </p>
          </div>

          <div className="blog__cards">
            <img src={best_way} alt="best-way"/>
            <p className="blog__topic">Best Way Rise Curreancy</p>
            <p className="blog__date">27 January, 2021</p>
            <p className="blog__words">
              Lorem ipsum dolor sit amet, consectetur sing to  sed do eiusmod tempor incididunt ut labore  dolore magna aliqua dolor.
            </p>
          </div>
        </div>

        <div className="view-more">
          <p>View More</p>
        </div>
        

      </div> */}

			<div className="get-instant">
				<div className="get-instant__left">
					<img src={get_instant} alt="get-instant" />
				</div>
				<div className="get-instant__right">
					<p className="get-instant__join">
						Thousands of people making the right choice
					</p>
					<p className="get-instant__topic">Get instant alert on your inbox</p>

					<p className="get-instant__text">
						We receive alot of new bid submission at our website. Subscribe to
						our newsletter and get instant bid alert on your inbox to apply.{" "}
					</p>

					<form
						onSubmit={sendWaitlist}
						method="POST"
						className="get-instant__mail">
						<div className="get-instant__mail__wrapper">
							<img src={email_icon} alt="email_icon" />
							<input
								type="email"
								placeholder="Enter Your Email"
								value={data.email}
								name="email"
								onChange={changeHandler}
							/>
						</div>

						<input
							type="submit"
							value="Subscribe"
							className="get-instant__subscribe"
							onClick={handleModal}
						/>
					</form>
				</div>
			</div>

			<div className="contact">
				<p className="contact__topic">Contact Us</p>
				<p className="contact__text">We want to hear from you</p>

				<div className="contact__wrapper">
					<div className="contact__left">
						<p>Primary Contacts</p>
						<p>Magodo Phase II, Lagos</p>
						<p>+234 70 3773 2914</p>
						<p>info@iexchangeng.com</p>
					</div>
					<div className="contact__right">
						<form action="POST" onSubmit={sendHelpdesk}>
							<div className="contact__right__top">
								<input
									type="text"
									name="name"
									placeholder="Name"
									onChange={helpDeskChangeHandler}
									value={helpDeskData.name}
								/>
								<input
									type="email"
									name="email"
									placeholder="Email"
									onChange={helpDeskChangeHandler}
									value={helpDeskData.email}
								/>
							</div>
							<textarea
								name="message"
								id=""
								cols="30"
								rows="10"
								placeholder="Message"
								onChange={helpDeskChangeHandler}
								value={helpDeskData.message}></textarea>
							<button
								type="submit"
								// value="Send Message"
								className="contact__send-message"
								onClick={sendHelpdesk}>
								Send Message
							</button>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default AboutPage;
